export { GoogleSearch };

let GoogleSearch = {

    init() {
        this.initSearchAndPagination();
        this.initLoadMoreButton();
    },

    initSearchAndPagination() {
        $(document).on('submit', '.search-form > form, form.search-form', function (e) {
            e.preventDefault();

            let $form = $(e.currentTarget),
                query = $form.find('[name="q"]').val(),
                page = $form.find('[name="page"]').val(),
                sort = $form.find('[name="sort"]').length > 0 ? $form.find('[name="sort"]').val() : null,
                submitUrl = $form.attr('action') + '/q:' + query + '/page:' + page;

            if (sort !== null) {
                submitUrl += '/sort:' + sort;
            }
            window.location.href = submitUrl;
        });

        $(document).on('keypress', '#visible-query', (e) => {
            if (e.which === 13) {
                this.submitSearchQuery();
            }
        }).on('click', '#search-button', (e) => {
            this.submitSearchQuery();
        });

        $(document).on('change', '#sort-options', function () {
            $('.search-form > form').submit();
        });

        $(document).on('click', 'a.search-page-link', function (e) {
            e.preventDefault();

            $('#hidden-page').val($(e.currentTarget).data('page'));
            $('.search-form > form').submit();
        });
    },

    initLoadMoreButton() {
        $('body').on('click', '#load-more-results-button', function (e) {
            e.preventDefault();

            let $button = $(this),
                url = $button.data('url'),
                $loadedPostsDiv;

            $button.prop('disabled', true).find('.default').addClass('d-none')
            $button.find('.loading').removeClass('d-none');

            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'html'
            }).done(function (posts) {
                $loadedPostsDiv = $('.post-list > .row:last');

                const targetX = $loadedPostsDiv.offset().top + $loadedPostsDiv.outerHeight();

                // Insert loaded posts
                $loadedPostsDiv.after($(posts));

                lazyLoadInstance.update();

                // Scroll to the first row of loaded posts
                $('html, body').animate({scrollTop: targetX}, 1000);

                $button.prop('disabled', false).find('.default').removeClass('d-none')
                $button.find('.loading').addClass('d-none');

                let matches = url.match(/(?<url>.+)(?<page>[0-9]+)\/layout:blank$/),
                    nextPage = parseInt(matches['groups']['page'] ?? 0) + 1;

                $button.data('url', matches['groups']['url'] + nextPage.toString() + '/layout:blank');
            });

            return false;
        });
    },

    submitSearchQuery() {
        if ($('#visible-query').val() === '') {
            return;
        }

        $('#search-button').prop('disabled', true);
        $('#hidden-query').val($('#visible-query').val());
        $('.search-form > form, form.search-form').submit();
    }

}